import classNames from "classnames"
import type { ClipboardEvent } from "react"

export const CODE_LENGTH = 6

interface Props {
  value: string
  onChange: (code: string) => void
  onComplete: (code: string) => void
  invalid?: boolean
  disabled?: boolean
}

export default function CodeInput({ value, onChange, onComplete, invalid, disabled }: Props) {
  const formatCode = (raw: string) => {
    return raw.replace(/\D/g, "").slice(0, CODE_LENGTH)
  }

  const handleChange = (raw: string) => {
    const digits = formatCode(raw)
    onChange(digits)

    // Submit as soon as the code is filled, including via SMS autofill
    if (digits.length === CODE_LENGTH && value.length < CODE_LENGTH) {
      onComplete(digits)
    }
  }

  // A pasted code can be formatted, e.g. "437-923"; maxLength would truncate it to "437-92"
  // before handleChange strips the dash, so strip it before the browser inserts it
  const handlePaste = (e: ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault()

    const digits = formatCode(e.clipboardData.getData("text"))
    handleChange(digits)
  }

  return (
    <input
      className={classNames("form-control form-control-lg join-code", { "is-invalid": invalid })}
      type="text"
      inputMode="numeric"
      autoComplete="one-time-code"
      autoFocus
      maxLength={CODE_LENGTH}
      placeholder="000000"
      value={value}
      disabled={disabled}
      onChange={(e) => handleChange(e.target.value)}
      onPaste={handlePaste}
    />
  )
}
